<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  collegeClassComputed,
  authComputed,
  collegeClassListMethod,
  collegeListMethod,
  collegeComputed,
  departmentListMethod,
  departmentComputed,
  siteListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Class',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      name: '',
      classCode: '',
      collegeError: null,
      collegeDataStatus: false,
      isCollegeError: false,
      isLoading: false,
      show: false,
      platformId: 0,
      collegelist: [],
      collegeId: null,
      departmentlist: [],
      departmentId: null,
      siteconfiglist: [],
    }
  },
  computed: {
    ...collegeClassComputed,
    ...authComputed,
    ...collegeComputed,
    ...departmentComputed,
  },
  mounted() {
    if (this.role === 'admin') {
      this.getListOfPlatform()
      this.getColleges()
    } else {
      this.platformId = this.currentUser.user.platform_id
    }
    this.collegeId = this.profileData.college_id
    this.getDepartments()
    if (this.role === 'administrator') {
      this.getColleges()
    }
  },
  methods: {
    ...collegeClassListMethod,
    ...collegeListMethod,
    ...departmentListMethod,
    ...siteListMethod,

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          // listitems.push({value:'All', text: 'All'})
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    // save college method
    saveCollegeClass() {
      const Data = {
        name: this.name,
        classCode: this.classCode,
        college_id: this.collegeId,
        department: this.departmentId,
        platform_id: this.platformId,
      }
      this.isLoading = true
      this.addCollegeClassData({ Data })
        .then((college) => {
          this.isLoading = false
          this.$router.push({ name: 'collegeclass.list' })
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.collegeError = getError.message
          this.isCollegeError = true
          window.scrollTo(0, 0)
        })
    },

    getColleges() {
      this.collegeId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select College',
            disabled: true,
          })
          college.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Department',
            disabled: true,
          })
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.classCode.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isCollegeError"
              variant="danger"
              v-html="collegeError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="saveCollegeClass"
            >
              <b-form-group
                v-if="role === 'admin'"
                label="Select Platform*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="platformId"
                  :options="siteconfiglist"
                  @change="getColleges"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role === 'administrator' || role === 'admin'"
                label="Select College*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeId"
                  :options="collegelist"
                  @change="getDepartments"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Department*" label-for="input-1">
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Class Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="name"
                  type="text"
                  placeholder="Enter Class Name"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Class Code*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="classCode"
                  type="text"
                  placeholder="Enter Class Code"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/college-class-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
</style>
